// De tre veje ind i spillet: alene, med en ven (M4, src/net) og med Volt (M3, src/ai).
// Samme knapper på titlen og forsiden, så man kan genkende dem.

import { h } from '../dom';
import { ICON } from '../icons';

export type PlayMode = 'solo' | 'friend' | 'volt';

const MODE: Record<PlayMode, { label: string; hint: string; cls: string }> = {
  solo: { label: 'Spil alene', hint: 'Dig og nettet', cls: 'primary' },
  friend: { label: 'Spil med en ven', hint: 'To skærme, ét net', cls: 'secondary friend' },
  volt: { label: 'Spil med Volt (AI)', hint: 'En AI-makker bygger med', cls: 'volt-play' },
};

function icon(m: PlayMode): HTMLElement {
  if (m === 'solo') return h('span', { class: 'mode-icon', html: ICON.play, 'aria-hidden': 'true' });
  if (m === 'friend') return h('span', { class: 'mode-icon friend-marks', 'aria-hidden': 'true' }, h('i', { class: 'p1' }), h('i', { class: 'p2' }));
  return h('span', { class: 'mode-icon volt-face-sm', 'aria-hidden': 'true' });
}

let hintN = 0;

/** Én vej ind. `hint` viser den lille forklaring under navnet (forsiden); titlen holder det kort. */
export function modeButton(m: PlayMode, onclick: () => void, opts: { hint?: boolean; autofocus?: boolean } = {}): HTMLButtonElement {
  const d = MODE[m];
  const hintId = opts.hint ? `mode-hint-${++hintN}` : undefined;
  return h(
    'button',
    {
      type: 'button',
      class: `btn mode-btn mode-${m} ${d.cls}`,
      autofocus: opts.autofocus,
      // Navnet er kun selve vejen; forklaringen læses som beskrivelse.
      'aria-label': d.label,
      'aria-describedby': hintId,
      onclick,
    },
    icon(m),
    h('span', { class: 'mode-text' }, h('b', {}, d.label), hintId ? h('small', { id: hintId }, d.hint) : null),
  );
}

/** Knapperne samlet i én gruppe. */
export function playModes(buttons: (HTMLElement | null)[], cls = ''): HTMLElement {
  return h('div', { class: `play-modes ${cls}`.trim(), role: 'group', 'aria-label': 'Hvordan vil du spille?' }, ...buttons);
}
